
export const Dark = {
    background: "#052C39",
    //accent: "#18808C"
    accent: "#FFFFFF"
}